<template>
  <div class="createAcct">
    <navbar></navbar>
    <svgicon icon="design-element" class="design-element"></svgicon>
    <div class="createAcct__wrap forgot-email-sent-container">
      <h6 class="createAcct__title signup__title">Reset your password</h6>
      <p class="signup__subtitle mb-5">
        Reset your password
      </p>

      <div class="createAcct__form">
        <form class="set_admin_password_form">
          <div class="mb-4">
            <float-label class="form__input-wrap mb-2">
              <input
                type="password"
                v-model="password"
                required
                placeholder="New Password"
                class="form__input"
              />
            </float-label>
            <FormError :validation-msg="validationMsg($v.password)" />
          </div>

          <div class="mb-4">
            <float-label class="form__input-wrap mb-2">
              <input
                type="password"
                v-model="confirmPassword"
                required
                placeholder="Confirm Password"
                class="form__input"
              />
            </float-label>
            <FormError :validation-msg="validationMsg($v.confirmPassword)" />
          </div>

          <PasswordStrength :password="password" class="mb-4 mt-5" />
          <PasswordRequirement :password="password" class="mb-3" />

          <button
            type="button"
            class="createAcct__ctaBtn mt-5"
            @click.prevent="submit"
          >
            <svgicon
              v-if="loading"
              icon="spinner"
              class="button__loader"
            ></svgicon
            >Reset Password
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import navbar from "../navbar";
import FormError from "../../resuables/form-error.vue";
import PasswordRequirement from "../../resuables/password-requirement.vue";
import PasswordStrength from "../../resuables/password-strength.vue";
import { required } from "vuelidate/lib/validators";
import { validationMessage } from "vuelidate-messages";
import { passwordStrengthCalculator } from "../../../utils/index";
import { setAdminPassword } from "../../../../services/dashboard";

const formMessages = {
  passwordRequired: () => "Password is required",
  confirmPasswordRequired: () => "Password must match"
};

export default {
  name: "change-password",
  components: {
    navbar,
    FormError,
    PasswordRequirement,
    PasswordStrength
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false,
      error: null,
      errorMessage: "",
      token: this.$route.params.id
    };
  },
  validations: () => {
    return {
      password: {
        passwordRequired: required
      },
      confirmPassword: {
        confirmPasswordRequired(value) {
          return value === this.password;
        }
      }
    };
  },
  methods: {
    validationMsg: validationMessage(formMessages),

    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.error = this.$v;
      } else {
        if (passwordStrengthCalculator(this.password) === 100) {
          this.loading = true;
          try {
            const response = await setAdminPassword({
              password: this.password,
              token: this.token
            });
            if (response.statusCode === 200) {
              this.$notification.success({
                message: "Password Reset Successful",
                description: response.message
              });
              this.$store.dispatch("auth/logout");
              this.$router.push("/");
            }
          } catch (error) {
            return error;
          } finally {
            this.loading = false;
          }
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/authentication/forgot-password/change-password.vue